export default __webpack_public_path__ + "static/media/Icon31.12caec56.svg";